import { useEffect } from 'react';
import { useNewsContext } from './context';
import { observer } from 'mobx-react';
import * as dateFns from 'date-fns';
import { SENSITIVE_VALUES } from '../../../../../components/Module/Table/Filters/FilterInput/constants';

export interface NewsActivatorProps {
  status: 'enabled' | 'disabled';
  children: JSX.Element;
}

export const NewsActivator = observer(
  ({ status, children }: NewsActivatorProps) => {
    const { layerLoader, cardToMouseLink } = useNewsContext();

    useEffect(() => {
      if (status === 'disabled') return;

      layerLoader.query = {
        filter: [
          [
            {
              field: 'date_end',
              operator: SENSITIVE_VALUES.gte,
              value: dateFns.format(new Date(), 'yyyy-MM-dd'),
            },

            { field: 'is_checked', value: 'true' },
            { field: 'is_archived', value: 'false' },
          ],
        ],
      };

      layerLoader.show();

      cardToMouseLink.bind();
    }, []);

    if (status === 'disabled') return <></>;

    return children;
  },
);
